"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const material_1 = require("@mui/material");
const ArgusMenuDropdown_1 = tslib_1.__importDefault(require("./ArgusMenuDropdown"));
const ArgusMenuLink_1 = tslib_1.__importDefault(require("./ArgusMenuLink"));
const ArgusMenuLogin_1 = tslib_1.__importDefault(require("./ArgusMenuLogin"));
const ArgusMenuLogo_1 = tslib_1.__importDefault(require("./ArgusMenuLogo"));
const ArgusMenuSearch_1 = tslib_1.__importDefault(require("./ArgusMenuSearch"));
const ArgusMenuUserMenu_1 = tslib_1.__importDefault(require("./ArgusMenuUserMenu"));
const useBreakpoints_1 = require("./useBreakpoints");
/**
 * Component displaying the argus menu.
 *
 * @example Usage
 * ```tsx
 * import ArgusMenu, {
 *  permissionCheckerUtil,
 *  getMenuConfig,
 * } from "@mnemonic/mui5/ArgusMenu";
 * import Logger from "@mne-core/logging";
 * import { getTargetMeta } from "@mne-core/providers";
 *
 * //...
 * const { domain } = getTargetMeta();
 *
 * <ArgusMenu
 *  {...{
 *   ...permissionCheckerUtil(
 *     session,
 *     getMenuConfig(domain, session?.user, Logger?.getInstance())
 *   ),
 *   logger: Logger?.getInstance(),
 * }}
 * />;
 * ```
 **/
const ArgusMenuComp = ({ logger, logo, nav, userMenu }) => {
    const { isDesktop } = (0, useBreakpoints_1.useBreakpoints)();
    return (react_1.default.createElement(material_1.AppBar, { component: "nav", sx: {
            display: "flex",
            flexDirection: "row",
            height: "64px",
            "@media print": {
                display: "none",
            },
        } },
        isDesktop && react_1.default.createElement(ArgusMenuLogo_1.default, { ...{ ...logo, logger } }),
        react_1.default.createElement(material_1.List, { sx: {
                display: "flex",
                flexDirection: "row",
                p: 0,
                pl: 1,
                height: "64px",
                width: "100%",
            } },
            nav?.items?.map((props) => {
                switch (props.kind) {
                    case "externalLink":
                    case "internalLink":
                        return (react_1.default.createElement(ArgusMenuLink_1.default, { ...{
                                ...props,
                                logger,
                                key: props.label,
                                ListItemProps: { sx: { flex: 0, px: 0 } },
                            } }));
                    case "dropdown":
                        return (react_1.default.createElement(ArgusMenuDropdown_1.default, { ...{
                                ...props,
                                logger,
                                key: props.label,
                                ListItemProps: { sx: { flex: 0, px: 0 } },
                            } }));
                    case "search":
                        return react_1.default.createElement(ArgusMenuSearch_1.default, { key: "search", ...props, logger: logger });
                    // Cases not handled by this switch returns null.
                    // We want to handle them like this, and only let unknown types fall thou to the default case.
                    case "contactUs":
                    case "button":
                        return null;
                    default:
                        // @ts-expect-error props.kind should always be never. If not you may have forgotten to add a clause in this switch.
                        logger.logError(`Unknown menu type: ${props.kind}`);
                        return null;
                }
            }),
            !userMenu?.name && (react_1.default.createElement(ArgusMenuLogin_1.default, { ...{
                    key: "login",
                    logger,
                    sx: { marginLeft: "auto", width: "auto" },
                } })),
            userMenu?.name && (react_1.default.createElement(ArgusMenuUserMenu_1.default, { ...{
                    ...userMenu,
                    key: "userMenu",
                    logger,
                    ListItemProps: { sx: { marginLeft: "auto", width: "auto" } },
                } })))));
};
exports.default = ArgusMenuComp;
